// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file patients/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.PatientMetadata
 */
export class PatientMetadata extends Message<PatientMetadata> {
  /**
   * Address of the patient
   *
   * @generated from field: string address = 1;
   */
  address = "";

  /**
   * Date of birth of the patient in YYYY-MM-DD format
   *
   * @generated from field: string date_of_birth = 2;
   */
  dateOfBirth = "";

  /**
   * Gender of the patient
   *
   * @generated from field: string gender = 3;
   */
  gender = "";

  constructor(data?: PartialMessage<PatientMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PatientMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_of_birth", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "gender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PatientMetadata {
    return new PatientMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PatientMetadata {
    return new PatientMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PatientMetadata {
    return new PatientMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: PatientMetadata | PlainMessage<PatientMetadata> | undefined, b: PatientMetadata | PlainMessage<PatientMetadata> | undefined): boolean {
    return proto3.util.equals(PatientMetadata, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.Patient
 */
export class Patient extends Message<Patient> {
  /**
   * Unique identifier for the patient
   *
   * @generated from field: string patient_id = 1;
   */
  patientId = "";

  /**
   * Full name of the patient
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * Phone number of the patient
   *
   * @generated from field: string phone = 3;
   */
  phone = "";

  /**
   * Government-issued identifier (e.g., national ID, passport)
   *
   * @generated from field: string govt_identifier = 4;
   */
  govtIdentifier = "";

  /**
   * Additional metadata about the patient
   *
   * @generated from field: com.neulink.pharmacy.PatientMetadata metadata = 5;
   */
  metadata?: PatientMetadata;

  /**
   * Timestamp when the patient record was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Timestamp of the last visit by the patient\
   *
   * @generated from field: google.protobuf.Timestamp last_visited = 7;
   */
  lastVisited?: Timestamp;

  /**
   * Status of the patient (e.g., ACTIVE, INACTIVE)
   *
   * @generated from field: string status = 8;
   */
  status = "";

  constructor(data?: PartialMessage<Patient>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.Patient";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "patient_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "govt_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "metadata", kind: "message", T: PatientMetadata },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "last_visited", kind: "message", T: Timestamp },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Patient {
    return new Patient().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Patient {
    return new Patient().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Patient {
    return new Patient().fromJsonString(jsonString, options);
  }

  static equals(a: Patient | PlainMessage<Patient> | undefined, b: Patient | PlainMessage<Patient> | undefined): boolean {
    return proto3.util.equals(Patient, a, b);
  }
}

